import typeSelectors from "../modules/definition/types/selectors";
import itemSelectors from "../modules/items/selectors";
import syncSelectors from "../modules/sync/selectors";
import getAutoIgnoredRep from "../sync/utils/getAutoIgnoredRep";
import getSyncableRep from "../sync/utils/getSyncableRep";

/**
 * Ensures that lastSyncRep correctly matches the settings that were used
 * This is to fix an earlier bug where properties might be stored in lastSyncRep
 * that were not actually synced, thus causing future erasing of Scrivener values
 * @param {TimelineRecord} record
 * @returns {TimelineRecord}
 */
const repairSyncRecord = timelineRecord => {
  // If sync is disabled or we do not yet have a lastSyncRep
  // then there is nothign to repair.
  if (!timelineRecord.sync.settings.enabled || !timelineRecord.sync.lastSyncRep) {
    return timelineRecord;
  }

  // Otherwise, we need to reduce the lastSyncRep down to its syncable components
  const itemTypesById = syncSelectors.getItemTypesBySyncId(timelineRecord);
  const itemsById = itemSelectors.getItemsById(timelineRecord);

  return (
    timelineRecord
      .updateIn(
        ["sync", "lastSyncRep"],
        lastSyncRep =>
          getAutoIgnoredRep(
            getSyncableRep(lastSyncRep, timelineRecord.sync.settings),
            timelineRecord.sync.settings,
            typeSelectors.getTypesById(timelineRecord),
            syncSelectors.getSyncIgnoreExternalIds(timelineRecord),
            itemTypesById
          ).rep
      )
      // Note: We do not remove localToExternalIds when items are deleted, because sync is excluded
      // from Undo/Redo, which means the link would not be recovered if the user undid the change
      // (we should possibly consider changing that).
      // So for now, we strip them out here, because we do not need to worry about the Undo chain by then...
      // as well as in the selector where we use them
      .updateIn(["sync", "localToExternalIds"], localToExternalIds =>
        localToExternalIds.filter((externalId, localId) => itemsById.has(localId))
      )
  );
};

export default repairSyncRecord;
